import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useNavigate } from "react-router-dom";

import { Auth0SDKBridge } from "../services/Auth0TokenService";
import { initializeAuth0Axios } from "../services/Auth0Axios";
import {
  setAuth0Token,
  clearAuth0Token,
} from "../services/CommonService";

const AUTH_ROUTE = "/login";

const Auth0Initializer = ({ children }) => {
  const {
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    loginWithRedirect,
  } = useAuth0();

  const location = useLocation();
  const navigate = useNavigate();

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    initializeAuth0Axios();
  }, []);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const initialize = async () => {
      const returnTo =
        location.pathname +
        location.search +
        location.hash;

      if (!isAuthenticated) {
        clearAuth0Token();

        setInitialized(true);

        if (location.pathname !== AUTH_ROUTE) {
          navigate(AUTH_ROUTE, {
            replace: true,
            state: {
              returnTo,
            },
          });
        }

        return;
      }

      try {
        const token = await getAccessTokenSilently();

        setAuth0Token(token);
        setInitialized(true);
      } catch (error) {
        clearAuth0Token();
        setInitialized(true);
        await loginWithRedirect({
          appState: {
            returnTo,
          },
        });
      }
    };

    initialize();
  }, [
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    loginWithRedirect,
    location.pathname,
    location.search,
    location.hash,
    navigate,
  ]);

  return (
    <>
      <Auth0SDKBridge />

      {!initialized ? (
        <div className="h-screen flex items-center justify-center">
          <p>Initializing authentication...</p>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default Auth0Initializer;